import React, {useCallback, useMemo, useState} from "react";
import {IconButton} from "../../../features/management-v2/import/inputs";
import {usePrettyFileSize} from "../../../lib/files/usePrettyFileSize";
import {useFileSelect} from "../hooks/useFileSelect";
import BasicText from "../../../components/form-v2/basic-text";
import SaveIcon from "@mui/icons-material/Save";
import {useUploadFile} from "../hooks/useUploadFile";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "../hooks/useNavigateWithClientID";
import {useSiren} from "../SirenContext";
import {useParams} from "react-router-dom";
import {Layout} from "../Layout";
import {ErrorMessage} from "../ErrorMessage";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {useGetNumber} from "../hooks/useGetNumber";
import {HotlineNumber} from "../typedefs";

export const HotlineNumberEdit: React.FC = () => {


    const {id} = useParams();
    const {data, isLoading, error} = useGetNumber(id);

    const content = useMemo(() => {
        if (data) return <Form hotlineNumber={data}/>

        if (error) return <ErrorMessage text={"error loading contact"}/>

        if (isLoading) return <div className="flex justify-center p-8"><LoadingSpinner/></div>


    }, [
        data, isLoading, error
    ])


    return (
        <Layout menuCurrent={"hotline"}>
            <div className="bg-white shadow-md p-4 flex flex-col gap-4">
                {content}
            </div>
        </Layout>

    )


}


const Form = ({hotlineNumber}: { hotlineNumber: HotlineNumber }) => {

    const {navigateWithClientID} = useNavigateWithClientID();
    const {clientID} = useSiren()

    const [saveError, setSaveError] = useState<string | null>(null);
    const [saving, setSaving] = useState<boolean>(false);



    const [name, setName] = useState<string>(hotlineNumber.name)
    const [e164, setE164] = useState<string>(hotlineNumber.phoneNumber.e164)




    const canSave = useMemo(() => {
        if (name.trim() == "") {
            return false
        }

        if(e164.trim() == "") {
            return false
        }

        return true


    }, [e164, name])


    const save = useCallback(async () => {
        setSaving(true);
        setSaveError(null);


        const request = {
            name: name,
            e164: e164,
        }

        try {
            await platformAPI.patch(`api/hotline-numbers/${hotlineNumber.id}`, request)
            navigateWithClientID("/siren/hotlines?subPage=numbers")
        } catch (e) {
            setSaveError("error updating hotline number")
        }

        setSaving(false)


    }, [name, e164])

    return (
        <>
            <h1 className={"text-lg font-semibold"}>Edit Hotline Number</h1>


            <BasicText label={"Name"} value={name} onChange={setName} required/>
            <BasicText label={"Phone Number"} value={e164} onChange={setE164} required/>
            <div className={"flex flex-col gap-4"}>


                {canSave && (
                    <IconButton onClick={save} text={"Update"} loading={saving} icon={<SaveIcon/>}/>
                )}
                {saveError && (
                    <p className={"text-center text-red"}>{saveError}</p>
                )}


            </div>
        </>
    )
}
